module.exports = __webpack_public_path__ + "media/images/countrysquared/bv-1113385173986f1bd48e1c5b78a33ff9.svg";